import { useLangLabels } from "../../../../shared/lang/services/useLangLabels";
import { useRevisionChangeGridModel } from "../lang/useRevisionChangeGridModel";
import { FlexContainer } from "../../../../components/containers";
import VirtualGrid from "../../../../shared/react-table/VirtualGrid/VirtualGrid";
import { useGetAllRevisionChangesByTagTGD } from "../services/revisionChangeServices";
import { RevisionChangeInterface } from "../types/revisionChangeType";
import RevisionChangeStatus from "./RevisionChangeStatus";
import { CarrousellActionInterface } from "../../../../shared/react-table/VirtualGrid/types/VirtualGridTypes";
import RevisionChangeSupervisionForm from "./RevisionChangeSupervisionForm";

const RevisionChangeHistory = ({ item }: { item: RevisionChangeInterface }) => {
  const { lang } = useLangLabels();
  const gridModel = useRevisionChangeGridModel();
  const entityName = lang.revisionChange.revisionChangesHistory;

  const { data: revisionChanges, isFetching } = useGetAllRevisionChangesByTagTGD(item?.tagTGD);

  const carrousellComponents: CarrousellActionInterface = [
    {
      icon: "edit",
      popoverTitle: lang.revisionChange.supervision,
      component: (item: RevisionChangeInterface) => (
        <RevisionChangeSupervisionForm item={item} isDataUpdated={!isFetching} />
      ),
    },
  ];

  return (
    <FlexContainer>
      <VirtualGrid
        entityName={entityName}
        gridModel={gridModel}
        items={revisionChanges || []}
        title={entityName}
        carrousellComponents={carrousellComponents}
        height={10}
        renderOptionColumn={{
          headerName: lang.revisionChange.state,
          renderOption: item => <RevisionChangeStatus item={item} />,
        }}
        cellFormatter={{
          supervisionReason: value => (value ? value : lang.revisionChange.unsupervised),
          supervisionDate: value =>
            new Date(value).getFullYear() !== 2999 ? value : lang.revisionChange.unsupervised,
          supervisionUser: value => (value ? value : lang.revisionChange.unsupervised),
        }}
      />
    </FlexContainer>
  );
};

export default RevisionChangeHistory;
